import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { UserFormInputs } from "./interfaces/UserFormInputs";
import { UsersFormUI } from "./usersForm.ui";
import { makeRequestBody } from "./utils/makeRequestBody";
import { userEmpty } from "./utils/user.empty";
import { schema } from "./validations/validation";
import { usePatientService } from "../../hooks/api/Patient";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAlert } from "../../hooks/alert";
import { ApplicationRoutes } from "../../utils/navigation/applicationRoutes";
import { useLoginService } from "../../hooks/api/Login";
import { useAuth } from "../../hooks/auth";
import { LoginRequestBody } from "../../hooks/api/Login/interfaces/login.request";
import { useOptionService } from "../../hooks/api/options";
import { OptionResponse } from "../../hooks/api/options/interfaces/option.response";

export const UserFormContainer = () => {
  //const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const { getCity, getOptions } = useOptionService();
  const { postCreate } = usePatientService();
  const getCityRef = useRef(getCity);
  const getOptionsRef = useRef(getOptions);
  getCityRef.current = getCity;
  getOptionsRef.current = getOptions;
  const navigate = useNavigate();
  const formMethods = useForm<UserFormInputs>({
    defaultValues: userEmpty,
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });
  const { success, error } = useAlert();
  const { postLogin } = useLoginService();
  const { signIn } = useAuth();
  const [isGettingState, setIsGettingState] = useState(true);
  const [isGettingCity, setIsGettingCity] = useState(true);
  const [stateOptions, setStateOptions] = useState<OptionResponse[]>([]);
  const [cityOptions, setCityOptions] = useState<OptionResponse[]>([]);

  const {
    handleSubmit,
    register,
    formState: { isSubmitting: isLoading, errors },
    control,
    watch,
  } = formMethods;

  useEffect(() => {
    getOptionsRef.current().then((options) => {
      setStateOptions(options);
      setIsGettingState(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedState = watch("state");
  const selectedPhone = watch("phone");

  useEffect(() => {
    setIsGettingCity(true);
    if (
      selectedState !== undefined &&
      selectedState !== null &&
      selectedState !== ""
    ) {
      getCityRef.current(selectedState).then((options) => {
        setCityOptions(options);
        setIsGettingCity(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState]);

  /*useEffect(() => {
    if (id === 'new') return;
    setIsLoadingGetData(true);
    getUser(Number(id))
      .then((result) => {
        setValue('name', result.name);
        setValue('phone', result.phone);
        setValue('email', result.email);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);*/

  useEffect(() => {
    console.log(selectedPhone);
  }, [selectedPhone]);

  const onSubmit = handleSubmit(async (data: UserFormInputs) => {
    const password = Math.random().toString(36).slice(-10);
    const body = makeRequestBody(data, password);
    postCreate({ body })
      .then((res) => {
        const body: LoginRequestBody = {
          phone: data.phone,
          password: password,
        };
        postLogin({ body }).then((res) => {
          signIn(res.accessToken, res.user);
          success("Dados usuário salvos com sucesso!");
          navigate(ApplicationRoutes.DOCTORS);
        });
      })
      .catch((err) => {
        console.error(err);
        error(err.response.data.message);
      });
  });

  return (
    <UsersFormUI
      onSubmit={onSubmit}
      register={register}
      errors={errors}
      isLoading={isLoading}
      control={control}
      cityOptions={cityOptions}
      isGettingCity={isGettingCity}
      isGettingState={isGettingState}
      stateOptions={stateOptions}
    />
  );
};
